var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.016,
    height: 16,
    viewBox: "0 0 14.016 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Profile_icon",
    "data-name": "Profile icon",
    d: "M20743.879,18052.4h-.941a8.172,8.172,0,0,1-4.3-1.441c-.836-.57-2.242-1.775-2.242-3.4a2.02,2.02,0,0,1,2.016-2.018h9.98a2.023,2.023,0,0,1,2.02,2.018c0,1.629-1.41,2.834-2.254,3.408A8.122,8.122,0,0,1,20743.879,18052.4Zm-.531-8.084a3.958,3.958,0,1,1,3.961-3.961A3.961,3.961,0,0,1,20743.348,18044.318Z",
    transform: "translate(-20736.398 -18036.402)",
    fill: "var(--linear-gradient-color)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconActive);
export default __webpack_public_path__ + "static/media/profile-icon_active.1bd3d329ae34b952aa37a6aec817dd6d.svg";
export { ForwardRef as ReactComponent };